import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './styles.module.css'

const StaticMap = ({
  location,
  placeholder = 'Insira o endereço abaixo para ver o mapa',
  icon = '/img/icons/location.svg',
  smallerIcon,
  zoom = 16,
  mapScale = 2,
  markerUrl = `${process.env.CLOUDINARY_IMAGE_URL}/site/emcasa-pin`,
  mapSize = {}
}) => {
  const [imgSrc, setImgSrc] = useState()
  const [loaded, onImgLoad] = useState(false)

  useEffect(() => {
    if (location) {
      const {width, height} = mapSize

      const {lat, lng} = location

      const params = `zoom=${zoom}&size=${width ||
        window.innerWidth}x${Math.round(
        height || window.innerWidth * 0.75
      )}&scale=${mapScale}&maptype=roadmap&markers=scale:${mapScale}|icon:${markerUrl}|${lat},${lng}`

      const endpoint = `https://maps.googleapis.com/maps/api/staticmap?${params}&key=${process.env.GOOGLE_MAPS_API_KEY}`

      setImgSrc(endpoint)
    }
  }, [location])

  return (
    <div className={styles.ecStaticMap}>
      {imgSrc && (
        <img
          className={styles.ecStaticMap__img}
          src={imgSrc}
          alt="Mapa"
          onLoad={() => onImgLoad(true)}
        />
      )}
      <div
        className={classNames({
          [styles.ecStaticMapCover]: true,
          [styles.ecStaticMapCover_hide]: loaded
        })}
      >
        <img
          className={
            smallerIcon
              ? styles.ecStaticMapCover__icon_small
              : styles.ecStaticMapCover__icon
          }
          alt="Ícone"
          src={icon}
        />
        <p
          className={styles.ecStaticMapCover__text}
          style={
            placeholder ? {width: '232px', margin: '5px'} : {width: 'auto'}
          }
        >
          {placeholder}
        </p>
      </div>
    </div>
  )
}

StaticMap.propTypes = {
  location: PropTypes.object,
  zoom: PropTypes.number,
  icon: PropTypes.string,
  smallerIcon: PropTypes.bool,
  mapScale: PropTypes.number,
  markerUrl: PropTypes.string,
  mapSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  })
}

export default StaticMap
